export function clamp(value: number, min: number, max: number): number {
    return Math.min(Math.max(value, min), max)
}

export function debounce<T extends (...args: any[]) => void>(
    fn: T,
    delay: number
): T {
    let timeoutId: ReturnType<typeof setTimeout> | null = null

    return ((...args: any[]) => {
        if (timeoutId !== null) {
            clearTimeout(timeoutId)
        }
        timeoutId = setTimeout(() => {
            fn(...args)
        }, delay)
    }) as T
}

export function deepcopy<T>(value: T): T {
    return JSON.parse(JSON.stringify(value))
}

export function objentries<T extends object>(o: T) {
    return Object.entries(o) as [keyof T, T[keyof T]][]
}

export function convertStrToNum(str: string): string {
    return (
        str
            // keep only ASCII digits + both Eastern ranges
            .replace(/[^\d\u06F0-\u06F9\u0660-\u0669]/g, '')
            // Persian digits → ASCII
            .replace(/[\u06F0-\u06F9]/g, d => String(d.charCodeAt(0) - 0x06f0))
            // Arabic-Indic digits → ASCII
            .replace(/[\u0660-\u0669]/g, d => String(d.charCodeAt(0) - 0x0660))
    )
}
